import { useState } from 'react';

import { CalendarDays } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { Calendar } from '@nesso/ui/primitives/calendar';
import { Field, FieldLabel } from '@nesso/ui/primitives/field';
import { Popover, PopoverContent, PopoverTrigger } from '@nesso/ui/primitives/popover';

import { formatNumericShortDate } from '@/shared/lib/time-utils';

type Props = {
    value: Date;
    disabled?: boolean;
    onChange: (date: Date) => void;
};

export function RecordPaymentSheetDate({ value, disabled, onChange }: Props) {
    const [open, setOpen] = useState(false);

    return (
        <Field className="w-fit">
            <FieldLabel htmlFor="record-payment-date">Payment date</FieldLabel>
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        id="record-payment-date"
                        type="button"
                        variant="outline"
                        disabled={disabled}
                        className="h-auto w-fit justify-start border-input bg-input-background px-4 py-2 text-base font-normal has-[>svg]:px-4"
                    >
                        <CalendarDays />
                        {formatNumericShortDate(value)}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        mode="single"
                        required
                        selected={value}
                        defaultMonth={value}
                        disabled={{ after: new Date() }}
                        onSelect={(date) => {
                            onChange(date);
                            setOpen(false);
                        }}
                    />
                </PopoverContent>
            </Popover>
        </Field>
    );
}
